/**
 * #152 — Helper de timezone per-tenant.
 *
 * Cada tenant configura su `appTimeZone` (IANA). Si no, default
 * `America/Bogota` (paridad con legacy). El runtime usa
 * `normalizeAppTimeZone` para validar contra Intl + fallback seguro.
 *
 * `formatInTimeZone` reemplaza a `toLocaleString` cuando necesitamos
 * formato consistente (reportes, dashboards) sin depender del TZ del
 * runtime Lambda (siempre UTC).
 */
export const DEFAULT_APP_TIME_ZONE = 'America/Bogota';
export const TIME_ZONE_OPTIONS = [
    { value: 'America/Bogota', label: 'America/Bogota - Colombia' },
    { value: 'America/Mexico_City', label: 'America/Mexico_City - Mexico' },
    { value: 'America/Lima', label: 'America/Lima - Peru' },
    { value: 'America/Argentina/Buenos_Aires', label: 'America/Buenos Aires - Argentina' },
    { value: 'America/Santiago', label: 'America/Santiago - Chile' },
    { value: 'America/Caracas', label: 'America/Caracas - Venezuela' },
    { value: 'America/Guayaquil', label: 'America/Guayaquil - Ecuador' },
    { value: 'America/La_Paz', label: 'America/La_Paz - Bolivia' },
    { value: 'America/Panama', label: 'America/Panama - Panama' },
    { value: 'UTC', label: 'UTC' },
];
/**
 * Valida un timezone IANA contra Intl. Si vacío/invalid, retorna el default.
 */
export function normalizeAppTimeZone(value) {
    const raw = typeof value === 'string' ? value.trim() : '';
    if (!raw)
        return DEFAULT_APP_TIME_ZONE;
    try {
        new Intl.DateTimeFormat('en-US', { timeZone: raw }).format(new Date());
        return raw;
    }
    catch {
        return DEFAULT_APP_TIME_ZONE;
    }
}
/**
 * `true` si `value` es un IANA válido (sin coerción al default).
 */
export function isValidTimeZone(value) {
    const raw = typeof value === 'string' ? value.trim() : '';
    if (!raw)
        return false;
    try {
        new Intl.DateTimeFormat('en-US', { timeZone: raw }).format(new Date());
        return true;
    }
    catch {
        return false;
    }
}
/**
 * Formatea una fecha en el TZ del tenant. Default ISO local style
 * (`2026-06-05 14:23:45`).
 */
export function formatInTimeZone(date, timeZone = DEFAULT_APP_TIME_ZONE, opts = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
}) {
    const d = typeof date === 'string' ? new Date(date) : date;
    const tz = normalizeAppTimeZone(timeZone);
    return new Intl.DateTimeFormat('en-CA', { ...opts, timeZone: tz })
        .format(d)
        .replace(',', '');
}
//# sourceMappingURL=index.js.map